import * as yup from 'yup';

export interface FormData {
  name: string;
  email: string;
  phoneNumber: string;
  customerNumber: string;
  subject: string;
  alreadyCustomer: string;
  content: string;
}

export const SkadeType = {
  sundhed: 'Brug af sundhedsforsikring',
  bil: 'Skade - Bil',
  ejerskifte: 'Skade - Ejerskifte',
  husIndboFritidshus: 'Skade - Hus, indbo og fritidshus',
  kaeledyr: 'Skade - Kæledyr',
  rejse: 'Skade - Rejse',
  ulykke: 'Skade - Ulykke',
  ansvar: 'Skade - Ansvar',
  loensikring: 'Skade - Lønsikring'
};

yup.setLocale({
  mixed: {
    required: 'Dette felt er obligatorisk'
  }
});

export const validationSchema = (formData: FormData) => {
  return yup.object().shape({
    name: yup.string().required(),
    email: yup
      .string()
      .email(`${formData.email} er ikke en gyldig email`)
      .required(),
    phoneNumber: yup.string(),
    customerNumber:
      formData.alreadyCustomer === 'Ja'
        ? yup.string().required()
        : yup.string(),
    subject: yup.string().required(),
    alreadyCustomer: yup.string().required(),
    skadetype:
      formData.subject === 'Skade' ? yup.string().required() : yup.string(),
    content: yup.string().required()
  });
};


export const to = (body: any) => {
  if (
    body.subject === 'Mine private forsikringer' ||
    body.subject === 'Henvendelse på vegne af anden kunde' ||
    body.subject === 'Andre henvendelser' ||
    body.subject === 'Opsigelse af forsikring'
  ) {
    return 'service@gjensidige.dk';
  } else if (body.subject === 'Sundhedsforsikring') {
    return 'sundhed-odense@gjensidige.dk';
  } else if (body.subject === 'Sundhedsforsikring person') {
    return 'sundhed-info@gjensidige.dk';
  } else if (body.subject === 'Erhvervsforsikringer') {
    return 'erhverv@gjensidige.dk';
  } else if (body.subject === 'Landbrugsforsikringer') {
    return 'landbrug@gjensidige.dk';
  } else if (body.subject === 'Tilbud på en ny privatforsikring') {
    return 'salg@gjensidige.dk';
  } else if (body.subject === 'Skade') {
    if (body.skadetype === SkadeType.bil) {
      return 'bil@gjensidige.dk';
    } else if (body.skadetype === SkadeType.ejerskifte) {
      return 'ejerskifteskade@gjensidige.dk';
    } else if (
      body.skadetype === SkadeType.husIndboFritidshus ||
      body.skadetype === SkadeType.rejse
    ) {
      return 'privatskade@gjensidige.dk';
    } else if (body.skadetype === SkadeType.sundhed) {
      return 'webskade@gjensidige.dk';
    } else if (body.skadetype === SkadeType.kaeledyr) {
      return 'skadecenter@gjensidige.dk';
    } else if (body.skadetype === SkadeType.ulykke) {
      return 'ulykke@gjensidige.dk';
    } else if (body.skadetype === SkadeType.ansvar) {
      return 'ansvar@gjensidige.dk';
    } else if (body.skadetype === SkadeType.loensikring) {
      return 'loensikring@gjensidige.dk';
    }
  } else {
    return 'service@gjensidige.dk';
  }
};

export default validationSchema;
